document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions;
      function toNumber(v) {
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      }
      function getCurrentPriceNumber(hit) {
        const p = toNumber(hit.price);
        if (p != null) return p;
        const vmin = toNumber(hit.variants_min_price);
        if (vmin != null) return vmin;

        return null;
      }

      // Build compare-at display text using variants_compare_at_price_min/max
      function getCompareAtDisplay(hit) {
        const min = toNumber(hit.variants_compare_at_price_min ?? hit.compare_at_price);
        const max = toNumber(hit.variants_compare_at_price_max ?? hit.compare_at_price);

        if (min == null && max == null) return null;
        const cmin = min ?? max;
        const cmax = max ?? min;

        if (cmin == null || cmax == null) return null;
        if (cmin === cmax && cmax == hit.price) return null;
        // If equal → show one price; else show range
        if (cmin === cmax) {
          return `$${algoliaShopify.helpers.formatNumber(cmin)}`;
        }
        return `$${algoliaShopify.helpers.formatNumber(cmin)} - $${algoliaShopify.helpers.formatNumber(cmax)}`;
      }

      // Determine if we should show compare-at (only if compare > current price)
      const currentPrice = getCurrentPriceNumber(item);
      const compareMin = toNumber(item.variants_compare_at_price_min ?? item.compare_at_price);
      const compareMax = toNumber(item.variants_compare_at_price_max ?? item.compare_at_price);
      const maxCompare = compareMax ?? compareMin;

      const hasCompare =
        currentPrice != null &&
        maxCompare != null &&
        maxCompare > currentPrice;

      const compareText = hasCompare ? getCompareAtDisplay(item) : null;

      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => trackSearchAttribution(item)}"
        >
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                alt="${item.title}"
              />
            </div>

            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">
                ${item.product_type &&
        components.Highlight({ hit: item, attribute: "product_type" })
        }
              </div>
              
              ${item.meta?.judgeme?.badge
                ? html`
                    <div
                      class="jdgm-widget jdgm-preview-badge"
                      data-id="${item.id}"
                      data-auto-install="false"
                      dangerouslySetInnerHTML=${{ __html: item.meta.judgeme.badge }}
                    ></div>
                  `
                : ''
              }

              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                  <span class="algolia-variant">
                    ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                  </span>
                </div>
              </div>

              <div class="aa-ItemContentPrice ${item.variants_count > 1 && compareMin != compareMax && compareMin != null && compareMax != null ? 'compare-range' : ''}">
                <div class="aa-ItemContentPriceCurrent">
                  ${algoliaShopify.helpers.displayPrice(item, distinct)}
                </div>

                ${compareText
          ? html`<div class="aa-ItemContentPriceCompare">${compareText}</div>`
          : ""
        }
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components) {
    const toNumber = v => {
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
    };
    const priceMin = toNumber(hit.variants_min_price ?? hit.price);
    const priceMax = toNumber(hit.variants_max_price ?? hit.price);

    let priceText = "";
    if (priceMin != null && priceMax != null) {
      priceText =
        priceMin === priceMax
          ? `$${algoliaShopify.helpers.formatNumber(priceMin)}`
          : `$${algoliaShopify.helpers.formatNumber(priceMin)} - $${algoliaShopify.helpers.formatNumber(priceMax)}`;
    }

    // ----- COMPARE PRICE -----
    const compareMin = toNumber(hit.variants_compare_at_price_min);
    const compareMax = toNumber(hit.variants_compare_at_price_max);

    let compareText = null;
    if (
      compareMin != null &&
      compareMax != null &&
      compareMax > priceMin
    ) {
      compareText =
        compareMin === compareMax
          ? `$${algoliaShopify.helpers.formatNumber(compareMin)}`
          : `$${algoliaShopify.helpers.formatNumber(compareMin)} - $${algoliaShopify.helpers.formatNumber(compareMax)}`;
    }

    function displayDiscount(e, t, r) {
      if(compareMin != compareMax && compareMin != null && compareMax != null){
        return;
      }
        const n = 1 - r;
      return Number(t) && Number(t) > Number(e) ? ` ${Math.floor(100 * n)}%` : ""
    }

    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
        <img
          class="ais-hit--picture"
          src="${algoliaShopify.helpers.mediumImage(hit)}"
          alt="${hit.title} - ${hit.variant_title}"
        />

        <div class="ais-hit--details">
       ${hit.meta?.judgeme?.badge
                ? html`
                    <div
                      class="jdgm-widget jdgm-preview-badge"
                      data-id="${hit.id}"
                      data-auto-install="false"
                      dangerouslySetInnerHTML=${{ __html: hit.meta.judgeme.badge }}
                    ></div>
                  `
                : ''
              }
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
      hit.title,
      hit._distinct,
      hit.variant_title
    )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
      hit.vendor
    )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
      html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <div class="ais-hit--price ${hit.variants_count > 1 && compareMin != compareMax && compareMin != null && compareMax != null  ? 'compare-range' : ''}">
            ${hit.variants_count > 1
  ? html`<b>Starting at: $${algoliaShopify.helpers.formatNumber(hit.variants_min_price)}</b>`
  : html`<b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>`
  
}

          ${hit.variants_count < 2 && html`
                <p class="ais-hit--price-compare">
            ${compareText
        ? html`<span class="aa-price-compare">${compareText}</span>`
        : ""
      }
          </p>
              `}


          ${hit.variants_count < 2 && html`
                <span class="ais-hit--price-discount"
                  >${displayDiscount(
        hit.price,
        hit.compare_at_price,
        hit.price_ratio
      )}</span
                >
              `}
          </div>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
      html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
      html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
      html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
      html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
        tag =>
          html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
      )}
          </p>

          ${hit.meta?.custom?.short_description &&
  html`
    <div class="result-description text-start text-sm">
      ${renderRichTextToHtml(hit.meta.custom.short_description, html)}
    </div>
  `}

          ${hit.variants_count == 1 &&
          html`
                      <product-form>
  <form
    id="product_form_${hit.id}"
        action="/cart/add"
        method="post"
        enctype="multipart/form-data"
        class="ais-hit--cart shopify-product-form"
        accept-charset="UTF-8"
        onClick="${(e) => e.stopPropagation()}"
  >
    <input type="hidden" name="quantity" value="1"/>
    <input type="hidden" name="id" value="${hit.objectID}"/>
    ${hit.can_order ? html`
    <button
      onClick="${(e) => e.stopPropagation()}"
      name="add"
      type="submit"
      class="ais-hit--cart-button product-card__quick-add-buttonn btn btn-secondary btn-medium w-full"
    >
      ${algoliaShopify.translations.addToCart}
    </button>
    ` : html`
    <button
      type="button"
      class="ais-hit--cart-button ais-hit--cart-button__disabled"
      disabled
    >
      ${algoliaShopify.translations.outOfStock}
    </button>
    `}
  </form>
  </product-form>
          `}
          ${hit.variants_count > 1 &&
      html`
              <p class="ais-hit--cart">
                <button
                  type="button"
                  class="ais-hit--cart-button ais-hit--choose-options"
                  onClick="${(e) => {
          e.stopPropagation?.();
          algoliaShopify.helpers.handleItemClick(hit);
          window.location.href = algoliaShopify.helpers.instantsearchLink(hit);
        }}"
                >
                  Choose options
                </button>
              </p>
            `}

        </div>
      </div>
    `;
  });
});

function renderRichTextToHtml(richTextString, html) {
  try {
    const richText = JSON.parse(richTextString);

    function renderNode(node) {
      switch (node.type) {
        case 'root':
          return node.children.map(renderNode);

        case 'paragraph':
          return html`
            <div>
              ${node.children.map(renderNode)}
            </div>
          `;

        case 'list':
          return html`
            <ul>
              ${node.children.map(renderNode)}
            </ul>
          `;

        case 'list-item':
          return html`
            <li>
              ${node.children.map(renderNode)}
            </li>
          `;

        case 'text':
          return node.bold === true
            ? html`<strong>${node.value}</strong>`
            : node.value;

        default:
          return null;
      }
    }

    return renderNode(richText);
  } catch (e) {
    console.warn('Invalid rich text JSON', e);
    return null;
  }
}


document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    const hasResults = (data?.results?.nbHits || 0) > 0;
    
    return html`
      <div class="ais-page">
        <h1 class="ais-heading h2">Search results for: '<strong id="ais-current-query"></strong>'</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${algoliaShopify.translations.showFilters}
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
            ? html`
                <div class="ais-dynamic-widgets-container"></div>
              `
            : data.facets.map(
                facet =>
                  html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                    >
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header"
                        >${facet.title}</label
                      >
                      <input
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                      />
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `
              )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function (options) {
    const sortOrders = options.sortOrders || [];

    options.sortOrders = sortOrders.map((item) => {
      if (
        item.label === 'Price (DEC)' &&
        item.value === 'shopify_products_price_ratio_asc'
      ) {
        return {
          ...item,
          value: 'shopify_products_price_desc',
        };
      }
      return item;
    });

    return options;
  });
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
    window.requestAnimationFrame(function () {
      var el = document.getElementById('ais-current-query');
      if (el) el.textContent = (data.query || '').toUpperCase();
    });
    return html`
      ${data.hasOneResult &&
        html`
          <span class="ais-stats--nb-results">
            1 result found
          </span>
        `}
      ${data.hasManyResults &&
        html`
          <span class="ais-stats--nb-results">
            ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '} products
          </span>
        `}
    `;
  });
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchOptions",
    function (options) {
      options.facets = options.facets || {};
      options.facets.list = options.facets.list || [];
      options.facets.shown = options.facets.shown || [];
      options.facets.widgets = options.facets.widgets || [];

      const escapeName = (name) => name.replace(/\./g, "_");
      const getFacetByAttribute = (attribute) => {
        return (options.facets.list || []).find((f) => f && f.name === attribute) || null;
      };

      const addFacetIfMissing = (facetObj) => {
        const exists = options.facets.list.some((f) => f && f.name === facetObj.name);
        if (!exists) {
          options.facets.list.push(facetObj);
          options.facets.shown.push(facetObj);
        }
      };
      const getExistingRefinementListWidgetFn = () => {
        const existing = (options.facets.widgets || []).find(
          (w) => w && w.name === "refinementList" && typeof w.widget === "function"
        );
        return existing ? existing.widget : null;
      };
      // Helper: add refinementList widget if missing
      const addRefinementListWidgetIfMissing = (attribute, escapedName, searchable = true) => {
        const exists = options.facets.widgets.some(
          (w) => w && w.name === "refinementList" && w.params && w.params.attribute === attribute
        );
        if (!exists) {
          const facetObj = getFacetByAttribute(attribute);

          const existingWidgetFn = getExistingRefinementListWidgetFn();
          const fallbackWidgetFn = algoliaShopify.facetsWidgets?.refinementList;
          options.facets.widgets.push({
            name: "refinementList",
            facet: facetObj,
            widget: existingWidgetFn || fallbackWidgetFn,
            params: {
                operator: "and",
                limit: 10,
                container: `[class~='ais-facet-${escapedName}-container']`,
                templates: {
                  searchableNoResults: `<div>No matching for ${facetObj?.title || escapedName}</div>`,
                },
                cssClasses: {
                  root: "ais-facet",
                  header: "ais-facet--header",
                  body: "ais-facet--body",
                  item: "ais-facet--item",
                  label: "ais-facet--label",
                  checkbox: "ais-facet--checkbox",
                  active: "ais-facet--active",
                },
                attribute: attribute,
                searchable: searchable,
                searchablePlaceholder: `Search for ${facetObj?.title || escapedName}`,
            }
          });
        }
      };

      // ---------- Facet: Grade ----------
      const gradeFacet = {
        enabled: true,
        name: "meta.custom.grade",
        escapedName: escapeName("meta.custom.grade"),
        title: "Shop by Grade",
        type: "conjunctive",
        searchable: true,
        available_types: ["list"],
      };
      addFacetIfMissing(gradeFacet);
      addRefinementListWidgetIfMissing(gradeFacet.name, gradeFacet.escapedName, false);

      // ---------- Facet: Cut / Category ----------
      const cutFacet = {
        enabled: true,
        name: "meta.custom.cut_type",
        escapedName: escapeName("meta.custom.cut_type"),
        title: "Shop by Cut",
        type: "conjunctive",
        searchable: true,
        available_types: ["list"],
      };
      addFacetIfMissing(cutFacet);
      addRefinementListWidgetIfMissing(cutFacet.name, cutFacet.escapedName, false);
      const PRIORITY = [
        "meta.custom.grade",
        "meta.custom.cut_type",
        "price",
      ];

      const sortByPriority = (arr, getKey) => {
        return [...arr].sort((a, b) => {
          const ak = getKey(a);
          const bk = getKey(b);
          const ai = PRIORITY.indexOf(ak);
          const bi = PRIORITY.indexOf(bk);

          if (ai === -1 && bi === -1) return 0;
          if (ai === -1) return 1;
          if (bi === -1) return -1;
          return ai - bi;
        });
      };
      options.facets.shown = sortByPriority(options.facets.shown, (f) => f && f.name);
      options.facets.list = sortByPriority(options.facets.list, (f) => f && f.name);
      options.facets.widgets = sortByPriority(options.facets.widgets, (w) => w && w.params && w.params.attribute);
      return options;
    }
  );
});
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    options.detachedMediaQuery = 'none';
    options.openOnFocus = true;
    return options;
  });
});

// Attach Algolia Autocomplete panel into Shopify predictive search container (mobile-safe)
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  if (!MOBILE_MQ.matches) return;

  const HOST_SELECTOR = '.predictive-search__content';
  const INPUT_SELECTOR = '.predictive-search input[type="search"], .aa-Input';
  const PANEL_SELECTOR = '.aa-Panel';

  let scheduled = false;
  function scheduleAttach() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      attachPanel();
    });
  }

  function attachPanel() {
    if (!MOBILE_MQ.matches) return;

    const host = document.querySelector(HOST_SELECTOR);
    const panel = document.querySelector(PANEL_SELECTOR);
    const input = document.querySelector(INPUT_SELECTOR);

    if (!host || !panel || !input) return;
    if (document.activeElement !== input) return;

    if (host.offsetParent === null) return;

    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }

    if (panel.parentElement !== host) {
      host.appendChild(panel);
    }
  }

  document.addEventListener(
    'input',
    function (e) {
      if (e.target?.matches(INPUT_SELECTOR)) {
        scheduleAttach();
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (e) {
      if (e.target?.matches(INPUT_SELECTOR)) {
        scheduleAttach();
      }
    },
    true
  );

  function initObserver() {
    const root = document.querySelector('.predictive-search');
    if (!root) return;

    const mo = new MutationObserver(() => scheduleAttach());
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
